
 
export const FETCH_STREETS_REQUEST = 'streets/FETCH_STREETS_REQUEST';
export const FETCH_STREETS_SUCCESS = 'streets/FETCH_STREETS_SUCCESS';
export const FETCH_STREETS_FAILURE = 'streets/FETCH_STREETS_FAILURE';

 
export const FETCH_STREET_REQUEST = 'streets/FETCH_STREET_REQUEST';
export const FETCH_STREET_SUCCESS = 'streets/FETCH_STREET_SUCCESS';
export const FETCH_STREET_FAILURE = 'streets/FETCH_STREET_FAILURE';

 
export const DELETE_STREET_REQUEST = 'streets/DELETE_STREET_REQUEST';
export const DELETE_STREET_SUCCESS = 'streets/DELETE_STREET_SUCCESS';
export const DELETE_STREET_FAILURE = 'streets/DELETE_STREET_FAILURE';

 
export const CREATE_STREET_REQUEST = 'streets/CREATE_STREET_REQUEST';
export const CREATE_STREET_SUCCESS = 'streets/CREATE_STREET_SUCCESS';
export const CREATE_STREET_FAILURE = 'streets/CREATE_STREET_FAILURE';

 
export const UPDATE_STREET_REQUEST = 'streets/UPDATE_STREET_REQUEST';
export const UPDATE_STREET_SUCCESS = 'streets/UPDATE_STREET_SUCCESS';
export const UPDATE_STREET_FAILURE = 'streets/UPDATE_STREET_FAILURE';


export const UPDATE_FIELD = 'streets/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'streets/SET_DEFAULT_DATA';
